var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492.3,299.1c-5.8-5.8-13.6-9.1-21.8-9.1h-429c-8.2,0-16,3.3-21.8,9.1c-5.9,5.9-9.2,13.7-9.2,21.9 c0.1,8.3,3.3,16.1,9.1,21.8c5.8,5.8,13.6,9.1,21.8,9.1h429.1c8.2,0,16-3.3,21.8-9.1c5.8-5.8,9.1-13.6,9.1-21.8 C501.5,312.9,498.2,305,492.3,299.1z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.3,169.1c-5.8-5.8-13.6-9.1-21.8-9.1h-429c-8.2,0-16,3.3-21.8,9.1c-5.9,5.9-9.2,13.7-9.2,21.9 c0.1,8.3,3.3,16.1,9.1,21.8c5.8,5.8,13.6,9.1,21.8,9.1h429.1c8.2,0,16-3.3,21.8-9.1c5.8-5.8,9.1-13.6,9.1-21.8 C501.5,182.8,498.2,175,492.3,169.1z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.4e2dff07.svg";
export { ForwardRef as ReactComponent };